/**
 * Faculty 4 — Academics-style carousel: shared title on each slide + per-slide
 * image / name / description. Single carousel container with prev/next arrows.
 * Reuses existing faculty columns (no migration needed): `title`,
 * `title_text_color` (acts as base text color), `title_1_color` (highlight),
 * `background_color` (carousel surface), `cta_button_color` / `cta_text_color`
 * (arrow buttons), and `metadata` (cards).
 */

export const FACULTY_4_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    priority: 1,
    status: true,
    metaImg: "",
    altImg: "",
    metaTitle: "Faculty Name",
    metaDescription:
      "Short bio shown on the carousel slide. Use plain text; long bios scroll inside the slide on mobile.",
  },

  METADATA_TITLES: {
    metadata: "Faculty Carousel Slides",
  },

  FACULTY_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title (wrap highlight in { } e.g. Learning Led by {Distinguished Faculty})",
      value: "Learning Led by {Distinguished Faculty}",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Learning Led by {Distinguished Faculty}",
      required: false,
      defaultValue: "Learning Led by {Distinguished Faculty}",
      rows: 2,
    },
    {
      fieldName: "title_text_color",
      label: "Title / text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_1_color",
      label: "Title highlight color (for {...} text)",
      value: "#FFD700",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFD700",
      required: false,
      defaultValue: "#FFD700",
    },
    {
      fieldName: "background_color",
      label: "Carousel background color",
      value: "#291973",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#291973",
      required: false,
      defaultValue: "#291973",
    },
    {
      fieldName: "cta_button_color",
      label: "Arrow button background",
      value: "#E36E26",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E36E26",
      required: false,
      defaultValue: "#E36E26",
    },
    {
      fieldName: "cta_text_color",
      label: "Arrow icon color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Priority",
      fieldName: "priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Sort order (1, 2, 3…)",
      required: true,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show/Hide this slide",
      defaultValue: true,
    },
    {
      header: "Image",
      fieldName: "metaImg",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload faculty image (230×220)",
    },
    {
      header: "Image alt text",
      fieldName: "altImg",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the image",
    },
    {
      header: "Name / heading",
      fieldName: "metaTitle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Faculty name or slide heading",
    },
    {
      header: "Bio / description",
      fieldName: "metaDescription",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Faculty bio or slide description",
      rows: 4,
    },
  ],
};
